// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

const icons = {
	IconDashboard,
	IconDeviceAnalytics,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const Settings = {
	id: 'Settings',
	title: <FormattedMessage id="settings" />,
	icon: icons.IconDashboard,
	type: 'group',
	children: [
		{
			id: 'settings',
			title: <FormattedMessage id="settings" />,
			type: 'item',
			url: '/settings',
			icon: SettingsIcon,
			breadcrumbs: false,
		},
	],
};

export default Settings;

function SettingsIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>settings</title>
			<path
				d="M10.825 22C10.375 22 9.98765 21.85 9.66298 21.55C9.33831 21.25 9.14231 20.8833 9.07498 20.45L8.84998 18.8C8.63331 18.7167 8.42931 18.6167 8.23798 18.5C8.04665 18.3833 7.85898 18.2583 7.67498 18.125L6.12498 18.775C5.70831 18.9583 5.29165 18.975 4.87498 18.825C4.45831 18.675 4.13331 18.4083 3.89998 18.025L2.72498 15.975C2.49165 15.5917 2.42498 15.1833 2.52498 14.75C2.62498 14.3167 2.84998 13.9583 3.19998 13.675L4.52498 12.675C4.50831 12.5583 4.49998 12.4457 4.49998 12.337V11.662C4.49998 11.554 4.50831 11.4417 4.52498 11.325L3.19998 10.325C2.84998 10.0417 2.62498 9.68333 2.52498 9.25C2.42498 8.81667 2.49165 8.40833 2.72498 8.025L3.89998 5.975C4.13331 5.59167 4.45831 5.325 4.87498 5.175C5.29165 5.025 5.70831 5.04167 6.12498 5.225L7.67498 5.875C7.85831 5.74167 8.04998 5.61667 8.24998 5.5C8.44998 5.38333 8.64998 5.28333 8.84998 5.2L9.07498 3.55C9.14165 3.11667 9.33765 2.75 9.66298 2.45C9.98831 2.15 10.3756 2 10.825 2H13.175C13.625 2 14.0126 2.15 14.338 2.45C14.6633 2.75 14.859 3.11667 14.925 3.55L15.15 5.2C15.3666 5.28333 15.571 5.38333 15.763 5.5C15.955 5.61667 16.1423 5.74167 16.325 5.875L17.875 5.225C18.2916 5.04167 18.7083 5.025 19.125 5.175C19.5416 5.325 19.8666 5.59167 20.1 5.975L21.275 8.025C21.5083 8.40833 21.575 8.81667 21.475 9.25C21.375 9.68333 21.15 10.0417 20.8 10.325L19.475 11.325C19.4916 11.4417 19.5 11.5543 19.5 11.663V12.337C19.5 12.4457 19.4833 12.5583 19.45 12.675L20.775 13.675C21.125 13.9583 21.35 14.3167 21.45 14.75C21.55 15.1833 21.4833 15.5917 21.25 15.975L20.05 18.025C19.8166 18.4083 19.4916 18.675 19.075 18.825C18.6583 18.975 18.2416 18.9583 17.825 18.775L16.325 18.125C16.1416 18.2583 15.95 18.3833 15.75 18.5C15.55 18.6167 15.35 18.7167 15.15 18.8L14.925 20.45C14.8583 20.8833 14.6626 21.25 14.338 21.55C14.0133 21.85 13.6256 22 13.175 22H10.825ZM12.05 15.5C13.0166 15.5 13.8416 15.1583 14.525 14.475C15.2083 13.7917 15.55 12.9667 15.55 12C15.55 11.0333 15.2083 10.2083 14.525 9.525C13.8416 8.84167 13.0166 8.5 12.05 8.5C11.0666 8.5 10.2373 8.84167 9.56198 9.525C8.88665 10.2083 8.54931 11.0333 8.54998 12C8.55065 12.9667 8.88831 13.7917 9.56298 14.475C10.2376 15.1583 11.0666 15.5 12.05 15.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}
